import loadable from '@loadable/component';

export default loadable(
  () => import(/* webpackChunkName: "visitor-prioritzation" */ './VisitorPriortization')
);
